import { SharedUtilsModule } from '@tcc-mono/shared/utils';
import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from './components/data-table/data-table.component';
import { IonicModule } from '@ionic/angular';
import { DisplayCellDataPipe } from './pipes/display-cell-data.pipe';
import {
  FaIconLibrary,
  FontAwesomeModule
} from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faSquare,
  faSquareCheck,
  faSquareO,
  faSortUp,
  faSortDown,
  faSort
} from '@fortawesome/pro-light-svg-icons';
import {
  faCaretDown,
  faCaretUp
} from '@fortawesome/sharp-solid-svg-icons';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslocoModule } from '@ngneat/transloco';
import { GridColCountDataPipe } from './pipes/grid-col-count.pipe';
import { ColumnColorPipe } from './pipes/get-column-color.pipe';

const icons: IconDefinition[] = [
  faSquare,
  faSquareCheck,
  faSquareO,
  faSortUp,
  faSortDown,
  faSort,
  faCaretUp,
  faCaretDown
];
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    SharedUtilsModule,
    ScrollingModule,
    TranslocoModule
  ],
  declarations: [DataTableComponent, DisplayCellDataPipe, GridColCountDataPipe, ColumnColorPipe],
  exports: [DataTableComponent]
})
export class DataTableModule {
  private readonly _lib: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(...icons);
  }
}
